import { StyleSheet, Text, View } from 'react-native'
import { colors, fontWeight } from '../tokens'

type Props = {
  // Number of milestones to show as "active" — 0 before sending,
  // 3 once the user has confirmed they've sent it.
  active?: 0 | 3
}

// Reminder schedule mirrors server/src/modules/appeal-reminders.ts
// (DAY_60 / DAY_100 / DECISION_FOLLOWUP @ day 120). When that schedule
// changes, update these too.
const ITEMS = [
  { day: 'Day 60', label: 'First nudge' },
  { day: 'Day 100', label: 'Halfway check-in' },
  { day: 'Day 120', label: 'Decision due' },
] as const

export const FulfilmentReminders = ({ active = 0 }: Props) => (
  <View style={styles.row}>
    {ITEMS.map((item, i) => {
      const isOn = i < active
      const isLast = i === ITEMS.length - 1
      return (
        <View key={item.day} style={styles.cell}>
          {!isLast ? (
            <View style={[styles.connector, isOn && i + 1 < active && styles.connectorOn]} />
          ) : null}
          <View style={[styles.dot, isOn && styles.dotOn]} />
          <Text style={styles.day}>{item.day}</Text>
          <Text style={styles.label}>{item.label}</Text>
        </View>
      )
    })}
  </View>
)

const styles = StyleSheet.create({
  row: { flexDirection: 'row', marginTop: 18, alignItems: 'flex-start' },
  cell: { flex: 1, alignItems: 'center', paddingTop: 26, position: 'relative' },
  // Drawn from the centre of the current dot to past the next dot, so the
  // line visually links neighbouring milestones.
  connector: {
    position: 'absolute',
    top: 7,
    left: '50%',
    right: '-50%',
    height: 2,
    backgroundColor: colors.border,
  },
  connectorOn: { backgroundColor: colors.primary[700] },
  dot: {
    position: 'absolute',
    top: 1,
    width: 14,
    height: 14,
    borderRadius: 7,
    backgroundColor: colors.surface,
    borderWidth: 2,
    borderColor: colors.borderStrong,
  },
  dotOn: { backgroundColor: colors.primary[700], borderColor: colors.primary[700] },
  day: { fontSize: 13, fontWeight: fontWeight.bold, color: colors.ink },
  label: { fontSize: 11.5, color: colors.muted, marginTop: 2, textAlign: 'center' },
})
